import { render, staticRenderFns } from "./PrimeEmailInput.vue?vue&type=template&id=010954cc"
import script from "./PrimeEmailInput.vue?vue&type=script&lang=js"
export * from "./PrimeEmailInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports